import React from 'react';
import { Phone, CalendarClock, SearchCheck, PhoneCall, Heart } from 'lucide-react';
export function Availability() {
  const cards = [{
    icon: Phone,
    title: 'Call First for Fastest Help',
    copy: 'Emergency auto glass searches are time-sensitive. Calling the Howell Auto Glass Service Center is the fastest way to check openings.'
  }, {
    icon: CalendarClock,
    title: 'Glass Availability Matters',
    copy: 'Some windshields and vehicle glass may be in stock or easier to source quickly. Specialty glass may take longer.'
  }, {
    icon: SearchCheck,
    title: 'We Confirm the Best Next Step',
    copy: 'The team will ask about your vehicle, damage, location and insurance details so they can recommend repair, replacement or inspection.'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-925" data-mp="31d1bmczakb96">
      <div className="max-w-7xl mx-auto" data-id="element-926" data-mp="2xdinl8c6bk24">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-927" data-mp="2xchdb62zf1lg">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-928" data-mp="1921wgmkxs56c">
            <span className="text-emergencyBrand-red" data-id="element-929" data-mp="1dys7uwlsqclf">
              Same-Day Auto Glass Openings
            </span>{' '}
            May Be Available
          </h2>
          <p className="text-lg text-slate-600" data-id="element-930" data-mp="1n1jkgzqereen">
            Auto glass availability depends on your vehicle, the glass needed,
            insurance details and the day's schedule. Kosin's Glass will confirm
            the fastest available option when you call or submit the form.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8" data-id="element-931" data-mp="zae8ivnl969m">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-lg p-6 border border-slate-200 hover:border-emergencyBrand-red/40 hover:shadow-md transition-all" data-id="element-932" data-mp="14379r9julwgy" data-mpi={i}>
              <div className="w-12 h-12 bg-emergencyBrand-redLight rounded-lg flex items-center justify-center mb-5" data-id="element-933" data-mp="bktdhee5uijz">
                <card.icon className="w-6 h-6 text-emergencyBrand-red" data-id="element-934" data-mp="1ev7jawbifoil" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-935" data-mp="19ww8ai9hb7ys">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-936" data-mp="1noaq4lrnh349">{card.copy}</p>
            </div>)}
        </div>
        {/* Trust callout */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-5 sm:p-6 max-w-3xl mx-auto mb-10 flex items-start gap-4" data-id="element-937" data-mp="vxecvk1ogwgg">
          <div className="bg-emergencyBrand-redLight p-2.5 rounded-lg shrink-0" data-id="element-938" data-mp="r04q6c5oaywb">
            <Heart className="w-5 h-5 text-emergencyBrand-red" data-id="element-939" data-mp="14yumvqokywk5" />
          </div>
          <p className="text-slate-700 leading-relaxed" data-id="element-940" data-mp="zyzypuw6wl2s">
            <span className="font-bold text-slate-900" data-id="element-941" data-mp="zy6qsqlhvpj2">
              Local drivers trust Kosin's Glass.
            </span>{' '}
            Urgent glass damage is stressful. Kosin's Glass helps you quickly
            understand glass availability, insurance options and the safest next
            step.
          </p>
        </div>
        <div className="text-center" data-id="element-942" data-mp="2nx0qr9c1icny">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-943" data-mp="2ny22lg0vr36q">
            <PhoneCall className="w-5 h-5" data-id="element-944" data-mp="32ln3r4e72sc0" />
            Call 517-545-7772 to Check Availability
          </a>
        </div>
      </div>
    </section>;
}